import React from 'react';
export default class ModernResumeEmployment extends React.Component{

    getResumeBlock(data, index){
        let title = [];
        if(data.jobTitle){
			title.push(<span key="a" data-v-37c786be="">{data.jobTitle}</span>)
		}

        if (data.companyName){
            title.push(<span key="b" data-v-37c786be="">{data.companyName}</span>)
        }

        if (data.location){
            title.push(<span  key="c" data-v-37c786be="">{data.location}</span>)
        }

        let titleFinal = [];
        for(let i = 0; i < title.length; i++){
            titleFinal.push(title[i]);
            if(i + 1 < title.length){
                titleFinal.push(<span key={i} data-v-37c786be="" className="comma">, </span>)
            }
        }

        return  <div data-v-37c786be="" className="section-item" key={index}>
					
                    {data.endDate && data.startDate && <div data-v-37c786be="" className="section-date">
                        <span data-v-37c786be="">{data.startDate.toUpperCase()} -</span>
                        <span data-v-37c786be="">{data.endDate.toUpperCase()}</span>
                    </div>}
                    
					<div data-v-37c786be="" className="section-title">
                        {titleFinal}
                    </div>
					
                    <div data-v-37c786be="" className="section-description" dangerouslySetInnerHTML={{ __html: data.description }}></div>
                </div>
    }

    render(){
        return  <div data-v-37c786be="" className="section">
					<div data-v-37c786be="" className="section-left">
						<div data-v-37c786be="" className="section-headline">{this.props.title}</div>
					</div>
					<div data-v-37c786be="" className="section-right">
						{this.props.data.map((item, index) => {
							return this.getResumeBlock(item, index);
						})}
					</div>
                </div>

    }
}